export const genEmailLink = (emailAddress) => `mailto:${emailAddress}`;
export const TH_EMAIL_ADDRESS = 'info@techholding.co';
export const TH_FACEBOOK_URL = 'https://www.facebook.com/techholding';
export const TH_GITHUB_URL = 'https://github.com/TechHoldingLLC';
export const TH_LINKEDIN_URL = 'https://www.linkedin.com/company/tech-holding/';
export const TH_SCHEDULE_A_CALL = 'https://calendar.app.google/cX9KautYKr2rTyGV8';
